import { getBonus } from '@monorepo/utils'
import type { SupportedGeo } from '../geo/config'

export const CAPTCHA_KEY = (typeof window !== 'undefined' && window.env.APP_CAPTCHA_KEY) || ''
export const LANDING_NAME = (typeof window !== 'undefined' && window.env.APP_LANDING_NAME) || ''

export const getRegistrationBonus = (geo: SupportedGeo) =>
  getBonus({
    name: LANDING_NAME,
    geo,
    nameQuery: null,
    appBonus: typeof window !== 'undefined' ? window.env.APP_BONUSES : undefined,
  })
export const FORM_ID = 'formId'
export const LANDING_TYPE = 'mini_game' as const
export const GAME_CATEGORY = 'wheel' as const
